import { isNumber } from '.'

export const cssMin = (first, second) => `min(${first}, ${second})`
export const cssMax = (first, second) => `max(${first}, ${second})`
export const calc = (...operands) => `calc(${operands.join(' ')})`

export const px = value => `${value}px`
export const vh = value => `${value}vh`
export const vw = value => `${value}vw`
export const pc = value => `${value}%`

export const valueFromCss = (cssValue, decimals = null) => {
  const value = String(cssValue).replace(/px|vw|vh|%|em|rem/i, '')

  return isNumber(decimals) && decimals > 0 ? parseFloat(value).toFixed(decimals) : parseFloat(value)
}
